// extracted by mini-css-extract-plugin
export default {"iframeShell":"InfoModalWithIframe_iframeShell__SqxSU","modalBody":"InfoModalWithIframe_modalBody__d1GYT","hidden":"InfoModalWithIframe_hidden__7y3jg"};